import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoindorecabservice() {



  const cardData =
  {
    keyword: 'Pune to Indore Cab Service',
    heading: 'Sanavi Travels: Pune to Indore Cab Service',
    headingDescription: 'Sanavi Travels offers reliable Pune to Indore Cab Service, providing safe, comfortable, and hassle-free transportation for families, corporate travelers, tourists, and groups traveling from Pune to Indore. Our fleet of sedans, SUVs, and luxury cabs is well-maintained with spacious seating, air-conditioning, and ample luggage space, ensuring a smooth and relaxing long-distance journey. With professional chauffeurs, flexible one-way and round-trip cab options, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, reliable, and stress-free travel. We provide convenient doorstep pickup across Pune including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, Swargate, and Pune Railway Station, covering popular stops along the route and Indore city attractions. Choose Sanavi Travels for trusted Pune to Indore cab services, delivering comfort, safety, and a seamless long-distance travel experience.',

    top: 'Top Places to Visit in Indore with Sanavi Travels',


"topPlaces": [
  {
    "title": "Rajwada Palace",
    "description": "Rajwada Palace is a historic seven-story palace in Indore, showcasing a blend of Maratha, Mughal, and French architectural styles. Once the royal residence of the Holkar dynasty, it features grand courtyards, intricate balconies, and majestic gateways. The palace is a must-visit for history enthusiasts and architecture lovers."
  },
  {
    "title": "Lal Bagh Palace",
    "description": "Lal Bagh Palace, built in the 19th century, is another grand Holkar-era palace in Indore. It displays opulent interiors, sprawling gardens, and royal artifacts. Visitors can explore its galleries, antique furniture, and impressive marble structures, reflecting the city’s regal heritage."
  },
  {
    "title": "Kanch Mandir",
    "description": "Kanch Mandir, also known as the Glass Temple, is a Jain temple famous for its walls, ceilings, and floors covered with glass mosaics. The temple’s intricate craftsmanship, mirror work, and spiritual ambiance make it a unique attraction in Indore."
  },
  {
    "title": "Chhatris of Indore",
    "description": "The Chhatris are cenotaphs of the Holkar rulers located on the banks of the Khan River. Featuring beautifully carved domes and pillars, they offer scenic views of the river and gardens. The Chhatris are an important historical and cultural landmark in Indore."
  },
  {
    "title": "Khajrana Ganesh Temple",
    "description": "Khajrana Ganesh Temple is a famous religious site dedicated to Lord Ganesha. Devotees from across the region visit to seek blessings. The temple is known for its peaceful atmosphere and spiritual significance, making it a central part of Indore’s religious life."
  },
  {
    "title": "Patalpani Waterfall",
    "description": "Patalpani Waterfall, located near Indore, is a scenic natural spot surrounded by lush greenery. The waterfall is especially spectacular during monsoon, attracting tourists for picnics, trekking, and photography."
  },
  {
    "title": "Tincha Falls",
    "description": "Tincha Falls is another popular waterfall near Indore, ideal for nature lovers and adventure enthusiasts. Surrounded by forested hills, it is perfect for trekking, day trips, and enjoying the serene environment."
  },
  {
    "title": "Ralamandal Wildlife Sanctuary",
    "description": "Ralamandal Wildlife Sanctuary is a protected area in Indore featuring dense forests, hiking trails, and diverse flora and fauna. Visitors can enjoy birdwatching, nature walks, and picnics in this tranquil environment."
  },
  {
    "title": "Central Museum (Indore Museum)",
    "description": "The Central Museum in Indore showcases a wide collection of sculptures, artifacts, coins, and relics from the Holkar era and beyond. It provides cultural and historical insights into the region, making it a must-visit for history buffs."
  },
  {
    "title": "Sarafa Bazaar",
    "description": "Sarafa Bazaar is Indore’s famous night street food market, offering a variety of local delicacies like poha, jalebi, bhutte ka kees, and more. It is a lively spot for food lovers and a cultural experience reflecting Indore’s culinary richness."
  }
]
,




"services": [
    {
      "name": "Pune to Indore Cab Service",
      "description": "Pune to Indore Cab Service offers a safe, comfortable, and convenient travel solution for individuals, families, and corporate travelers. Fully air-conditioned cabs with spacious seating, ample luggage space, and smooth ride quality make long-distance travel hassle-free. Experienced chauffeurs ensure timely pickups, safe navigation, and flexible route planning. Ideal for one-way trips, round trips, weekend getaways, and corporate travel, this service prioritizes reliability, comfort, and affordability for an enjoyable Pune to Indore journey."
    },
    {
      "name": "Indore Cab from Pune",
      "description": "Indore Cab from Pune provides a reliable and efficient travel option for those commuting between Pune and Indore. Air-conditioned cabs with comfortable seating and professional chauffeurs ensure a smooth journey. Perfect for families, groups, corporate travelers, or solo passengers, this service allows flexible pickup and drop-off locations, on-time arrivals, and a stress-free travel experience across long distances."
    },
    {
      "name": "AC Cab Pune to Indore",
      "description": "AC Cab Pune to Indore ensures a comfortable long-distance journey with fully air-conditioned vehicles. Ideal for hot weather and summer travel, the cabs offer spacious seating, ample luggage space, and a smooth ride. Professional chauffeurs provide safe driving, efficient route planning, and timely pickups. Suitable for families, tourists, corporate travelers, and groups seeking convenience, reliability, and comfort on the Pune-Indore route."
    },
    {
      "name": "Luxury Cab Indore Trip",
      "description": "Luxury Cab Indore Trip provides premium travel with stylish, fully air-conditioned vehicles equipped with modern amenities. Designed for comfort-conscious travelers, this service is perfect for families, corporate groups, or couples seeking a high-end experience. Professional chauffeurs ensure punctuality, safety, and smooth navigation, allowing passengers to relax and enjoy a hassle-free journey from Pune to Indore."
    },
    {
      "name": "Family Cab Indore",
      "description": "Family Cab Indore is perfect for families traveling from Pune to Indore, offering spacious seating, air-conditioning, and ample luggage space. Professional drivers ensure a safe, comfortable, and enjoyable journey. This service is ideal for one-day trips, weekend getaways, or longer vacations, prioritizing family convenience, comfort, and reliability throughout the trip."
    },
    {
      "name": "Outstation Cab Indore",
      "description": "Outstation Cab Indore is designed for travelers seeking reliable long-distance transport between Pune and Indore. Fully air-conditioned vehicles with experienced chauffeurs guarantee a smooth and secure journey. Suitable for solo travelers, families, or corporate groups, the service allows flexible travel plans including one-way or round trips, making outstation travel stress-free and comfortable."
    },
    {
      "name": "Affordable Cab Indore",
      "description": "Affordable Cab Indore offers budget-friendly travel options without compromising on comfort or safety. Fully air-conditioned cabs with professional chauffeurs ensure a smooth journey from Pune to Indore. Ideal for students, families, and group travelers, this service provides an economical yet reliable and convenient long-distance travel experience."
    },
    {
      "name": "Chauffeur Driven Cab Indore",
      "description": "Chauffeur Driven Cab Indore ensures a professional, stress-free journey from Pune to Indore. Experienced drivers handle navigation, traffic, and route planning while passengers relax in air-conditioned, spacious vehicles with ample luggage space. Perfect for families, groups, corporate travel, or tourists seeking safety, comfort, and reliability on a long-distance journey."
    },
    {
      "name": "Best Cab Pune to Indore",
      "description": "Best Cab Pune to Indore offers a premium travel experience with comfortable, well-maintained, fully air-conditioned vehicles. Professional chauffeurs guarantee safe, timely travel and convenient route planning. Ideal for families, groups, corporate travelers, and solo tourists, this service ensures a smooth, reliable, and enjoyable journey between Pune and Indore."
    },
    {
      "name": "Pune Indore Taxi",
      "description": "Pune Indore Taxi is a dependable travel solution for long-distance journeys. Spacious, air-conditioned cabs with professional drivers offer comfort, safety, and reliability. Flexible pickup and drop options make this service convenient for families, groups, and corporate travelers seeking a hassle-free trip between Pune and Indore."
    },
    {
      "name": "Long Distance Cab Pune",
      "description": "Long Distance Cab Pune specializes in providing safe and comfortable travel for long-distance routes such as Pune to Indore. Air-conditioned vehicles with experienced chauffeurs ensure a stress-free journey. Ideal for family trips, corporate travel, or leisure excursions, this service combines convenience, comfort, and punctuality for travelers."
    },
    {
      "name": "Tourist Cab Indore",
      "description": "Tourist Cab Indore is perfect for travelers planning sightseeing or leisure trips from Pune to Indore. Fully air-conditioned, spacious cabs with professional chauffeurs provide a smooth, safe, and timely travel experience. This service is ideal for families, groups, and solo tourists, with options for flexible travel itineraries and comfortable long-distance journeys."
    },
    {
      "name": "One Way Cab Indore",
      "description": "One Way Cab Indore offers a convenient, cost-effective, and comfortable solution for travelers going from Pune to Indore without requiring a return trip. Fully air-conditioned vehicles and professional chauffeurs ensure a smooth, safe, and timely journey, making this service ideal for families, corporate travelers, or solo passengers seeking stress-free one-way travel."
    },
    {
      "name": "Round Trip Cab Indore",
      "description": "Round Trip Cab Indore provides a flexible solution for travelers planning to return to Pune after visiting Indore. Fully air-conditioned, well-maintained vehicles with professional chauffeurs ensure a safe, comfortable, and timely round trip. Suitable for family vacations, corporate travel, or group tours, this service combines convenience, reliability, and comfort for long-distance round journeys."
    },
    {
      "name": "Online Cab Booking Pune",
      "description": "Online Cab Booking Pune allows passengers to conveniently book cabs for Pune to Indore trips from anywhere at any time. Users can select vehicle type, pickup and drop locations, date, and trip duration with instant confirmation. Fully air-conditioned vehicles with professional chauffeurs ensure a smooth, safe, and timely journey, making online booking convenient, reliable, and stress-free."
    }
  ],
  "tableData": [
    ["Pune to Indore Cab Service", "Indore Cab from Pune"],
    ["AC Cab Pune to Indore", "Luxury Cab Indore Trip"],
    ["Family Cab Indore", "Outstation Cab Indore"],
    ["Affordable Cab Indore", "Chauffeur Driven Cab Indore"],
    ["Best Cab Pune to Indore", "Pune Indore Taxi"],
    ["Long Distance Cab Pune", "Tourist Cab Indore"],
    ["One Way Cab Indore", "Round Trip Cab Indore"],
    ["Online Cab Booking Pune", "—"]
  ]
,


"whychoose": [
  {
    "WhyChooseheading": "Pune to Indore Cab Service with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels provides reliable and comfortable cab services from Pune to Indore, ideal for business travel, family trips, and outstation journeys."
  },
  {
    "WhyChooseheading": "Comfortable and Well‑Maintained Cabs",
    "WhyChoosedescription": "Travel in air‑conditioned, clean, and regularly serviced cabs for a smooth and enjoyable journey from Pune to Indore."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed drivers are courteous, professional, and familiar with the Pune–Indore route to ensure safe, timely, and hassle‑free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides upfront and clear pricing for Pune to Indore cab bookings, including fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, travel queries, and itinerary updates."
  },
  {
    "WhyChooseheading": "Flexible Travel Options",
    "WhyChoosedescription": "Choose from one‑way, round‑trip, or customized cab packages based on your Pune to Indore travel requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure passenger safety and hygiene."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Pune to Indore cab services."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide cab services from Pune to Indore?',
    answer: 'Yes, Sanavi Travels offers reliable and comfortable cab services from Pune to Indore.'
  },
  {
    question: 'How can I book a Pune to Indore cab?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of cabs are available for Pune to Indore travel?',
    answer: 'Sanavi Travels provides sedans, SUVs, and premium cars suitable for long-distance travel.'
  },
  {
    question: 'Are drivers experienced on the Pune–Indore route?',
    answer: 'Yes, our drivers are professional and familiar with the Pune to Indore route to ensure a smooth and safe journey.'
  },
  {
    question: 'Can I choose custom pickup and drop‑off locations?',
    answer: 'Absolutely. You can select your preferred pickup in Pune and drop‑off in Indore.'
  },
  {
    question: 'Is the Pune to Indore cab service available 24x7?',
    answer: 'Yes, Sanavi Travels provides round-the-clock cab services to match your travel schedule.'
  },
  {
    question: 'Are the vehicles sanitized before the trip?',
    answer: 'Yes, all cabs are thoroughly cleaned and sanitized before every journey.'
  },
  {
    question: 'What payment options are available for cab bookings?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Pune to Indore trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajesh Kumar',
    feedback: 'Booked a cab from Pune to Indore with Sanavi Travels. Comfortable ride, professional driver, and timely service. Highly recommended!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Anjali Mehta',
    feedback: 'Great experience! The cab was clean and the journey was smooth. Excellent service from Sanavi Travels.',
    rating: 5
  }
];





















































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Indore Cab Service - Sanavi Travels",
  "description": "Book Pune to Indore cabs with Sanavi Travels. AC and luxury cabs for family trips, outstation journeys, long-distance travel, one-way or round trips, tourist trips, and comfortable chauffeur-driven service.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};





  return (
    <div>
<Helmet>
  <title>
    Pune to Indore Cab Service | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire AC and luxury cabs from Pune to Indore with Sanavi Travels. Ideal for family trips, outstation journeys, long-distance travel, one-way or round trips, tourist trips, and safe chauffeur-driven service."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/61.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoindorecabservice;